<template>
    <template v-if="link !== null">
        <a :href="getLinkUrl()" :title="link.Title" class="btn btn--primary">
            <span class="btn__text">{{ link.Text }}</span>
        </a>
    </template>
</template>
<script>
export default {
    name: 'LinkComponent',
    props: {
        link: {
            type: Object,
            default: null
        }
    },
    methods: {
        getLinkUrl() {
            return this.link.Link.Url.includes('#') ? `#module${this.link.Link.Url.substring(this.link.Link.Url.indexOf('#') + 1)}` : this.link.Link.Url;
        }
    }
};
</script>
